import { Component, OnInit } from '@angular/core';
import {PublicService} from '../public.service';
import { FormControl, Validators } from '@angular/forms';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  key = "deactive";
  key2 = "active";
  key3 = "deactive";
  phoneNum = "";
  name = "";
  email = "";
  loading = true;

  constructor(public publicservice : PublicService, public router: Router) { 
    if ( publicservice.logedIn == "false" || this.publicservice.logedIn == null ) {
      this.router.navigate(['login']);
    }
    this.publicservice.getProfile().then((r) => {
      this.loading = false;
      this.phoneNum = r.data.phone;
      console.log(this.phoneNum);
      
      this.name = r.data.name;
      this.email = r.data.email;
      
        // this.router.navigate(['home']);
      
    });
  }

  ngOnInit(): void {
    console.log(this.publicservice.logedIn);
    
    // if ( this.publicservice.logedIn == "false" || this.publicservice.logedIn == null ) {
    //   this.router.navigate(['login']);
    // }
  }

  profileset() {
    this.key2 = "deactive";
    this.key = "active";

    // this.publicservice.updateProfile().then(r => {
    //   if( r.data == "email is not unique" ){
    //     this.key3 = "active";
    //   }
    //   this.name = r.data.user.name;
    //   this.email = r.data.user.email;
    // });
  }

  profileedit() {
    this.publicservice.updateProfile().then(r => {
      if( r.data == "email is not unique" ){
        this.key3 = "active";
      }else {
    this.key = "deactive";
    this.key2 = "active";
      

      this.publicservice.updateProfile().then(r => {
        this.name = r.data.user.name;
        this.email = r.data.user.email;
      });
    }
  });
  }


  backhome() {
    this.router.navigate(['home']);
  }

  getProfile() {
    // this.publicservice.getProfile().then(r => {
    //   this.phoneNum = r.phone;
    //   this.name = r.firstName + " " + r.lastName;
    //   this.email = r.email;
      
    //     // this.router.navigate(['home']);
      
    // });
  }
  
  exit() {
    // localStorage.removeItem('token');
    localStorage.setItem("logedInWaste", "false");
    localStorage.clear();
    this.router.navigate(['login']);
  }

}
